module.exports = __webpack_public_path__ + "static/img/c0.4d789009.svg";